/**
 * Track signup conversion.
 */
export const trackSignedUpForTaboola = (): void => {
  if (window._tfa) {
    window._tfa.push({ notify: 'event', name: 'signed_up' });
  }
};

/**
 * Track onboarded conversion.
 */
export const trackOnboardedForTaboola = (): void => {
  if (window._tfa) {
    window._tfa.push({ notify: 'event', name: 'onboarded' });
  }
};
